module.exports = __webpack_public_path__ + "img/bala.bf68dcf8.png";